import { createSignal, type Signal } from "solid-js"
import type { TilePositionXY } from "../../lib/core/tile_position_xy/TilePositionXY.type"
import { isListSameXY } from "../../lib/isListSameXY"
import { immutableEmptyArray } from "../../lib/lib"
import createSharedCachedFactory from "../memo/createSharedCachedFactory"

/**
 * The root data store for position selection with support for different selection modes.
 * 
 * @example
 * const [getSelectedPositions, setSelectedPositions, updateSelectedPosition] = useSelectedPositionListSignal()
 * 
 * // Single selection (replaces current selection)
 * updateSelectedPosition({x: 1, y: 2}, SelectionMode.SingleSelect)
 * 
 * // Add to selection
 * updateSelectedPosition({x: 3, y: 4}, SelectionMode.AddToSelection)
 * 
 * // Remove from selection
 * updateSelectedPosition({x: 1, y: 2}, SelectionMode.RemoveFromSelection)
 * 
 * // Toggle selection
 * updateSelectedPosition({x: 1, y: 2}, SelectionMode.ToggleSelection)
 */
export const useSelectedPositionListSignal = createSharedCachedFactory((): Signal<Array<TilePositionXY>> => {
  // eslint-disable-next-line solid/reactivity
  const signal = createSignal<Array<TilePositionXY>>(immutableEmptyArray as unknown as Array<TilePositionXY>, {
    equals: isListSameXY,
  })

  return signal
})


